<div fxFlex="100" class="companyD" fxLayout="row wrap">
    <!-- Report Name -->
    <app-text-field [isEditable]="true" [label]="'Report Name*'" [(ngModel)]="reportObj.name" [name]="'report_name'"
        [minlength]="5" [errors]="reportObj.error.name" fxFlex="12em">
    </app-text-field>

    <!-- Purpose of Report -->
    <app-text-field [isEditable]="true" [label]="'Purpose of Report*'" [(ngModel)]="reportObj.purpose"
        [name]="'purpose'" [isMultiline]="true" [minlength]="5" [errors]="reportObj.error.purpose" fxFlex="12em">
    </app-text-field>
    <!-- <quill-editor [styles]="{'min-height': '20px'}" [(ngModel)]="reportObj.description" id="description"
        [modules]="modules" #editor placeholder="Purpose of Report..." fxFlex="26.5em">
    </quill-editor> -->

    <!-- Report Name -->
    <app-text-field [isEditable]="true" [label]="'Fields in the Report*'" [(ngModel)]="reportObj.fields"
        [name]="'fields'" [isMultiline]="true" [minlength]="5" [errors]="reportObj.error.fields" fxFlex="26.5em">
    </app-text-field>
    <!-- <quill-editor [styles]="{'min-height': '20px'}" [(ngModel)]="reportObj.description" id="description"
        [modules]="modules" #editor placeholder="Fields in the Report..." fxFlex="26.5em">
    </quill-editor> -->

    <!-- User Access -->
    <app-mat-auto-search [isEditable]="true" [label]="'Access to*'" [(ngModel)]="reportObj.user_access"
        [name]="'user_access'" [idField]="null" [displayField]="'email'" [listUrl]="userListUrl" [multiple]="true"
        [closeOnSelect]="false" [showSelectAll]="true" (showAll)="addAllUsers($event)"
        [errors]="reportObj.error.user_access" fxFlex="26.5em">
        <!-- [labelItemTemplate]="userSelectedItem"        [itemTemplate]="userItem" -->
    </app-mat-auto-search>
</div>

<div class="btnb">
    <button mat-stroked-button class="Cancel" (click)="closeSidePanel()">Cancel</button>
    <button mat-stroked-button class="Save" [disabled]="disableSaveButton"
        (click)="onNewReportRequestSave()">Save</button>
</div>

<!-- <ng-template #userItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="userListShow">
        <span class="fullname">
            {{item?.first_name}} {{item?.last_name}}
        </span>
        <span class="email">
            {{item?.email}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.first_name}} {{item?.last_name}}
</ng-template>

<ng-template #userDisplayItem let-item>
    {{item?.first_name}} {{item?.last_name}}
</ng-template> -->